module.exports = __webpack_public_path__ + "img/b6f6dff345c5476579045ba4da7262c0.svg";